/**
 * Relation keys the Recurring Job manage surface mounts.
 *
 * Named keys rather than `ActivityEntityName.RecurringJobTemplateItem` / `.TaskTemplate`: each tab is
 * the recurring job's own view of those rows, and the entity name is already the board's, not the
 * relation's. Same reason Job names its Items / SOR tabs.
 */
export const RecurringJobRelationName = {
  Items: 'items',
  Tasks: 'tasks',
} as const;
